import { SystemBreakpoint } from '../../theme/System/Default/breakpoints';

const breakpointToFrameSizeSelector = (
  currentBp: SystemBreakpoint,
): 'mobile' | 'desktop' => (currentBp === 'mobile' ? 'mobile' : 'desktop');

export default breakpointToFrameSizeSelector;
